import React, { useState, useRef, useEffect } from 'react';
import { View, TextInput, Text, Image, Keyboard, Pressable } from 'react-native';

import { store } from '../../store/store';

import { pwaGUID } from '../CommonService';
import { doPost } from "../../utils/services/api/API";
import { NavigateToAppBaseScreen } from '../../utils/services/NavigationUtils';
import { buildOrderRequestData } from '../../utils/services/oms/buildOMSOrderData';
import { getSelectedChemistStoreId } from '../../utils/services/chemist/ChemistStoreUtils';
import { windowGTagEvent } from '../../utils/services/webapp-services/windowsInternalFunction';
import { MoengageEvents, trackMoengageEvents } from '../../utils/services/webapp-services/MoengageUtils';

import { CommonHeader } from '../../utils/widgets/CommonWidget/CommonHeader';

import { getToastContent } from '../../utils/constants/ToastContentMapping';
import { NavigateFrom, ScreenRoute } from '../../utils/constants/ScreenRouteConstant';

import PropTypes from 'prop-types';
import AppTheme from '../../AppTheme';
import AppStyles from "../../AppStyles";
import TextStyle from '../../TextStyle';
import ToastModal from '../../utils/modals/ToastModal';
import OTPTextInput from '../../utils/widgets/OTPTextInput';

import PlaceOMSOrder from '../../utils/services/oms/OMSPlaceOrder';
import RefreshCacheAction from '../../utils/services/webapp-services/RefreshCache';

import * as AlertService from "../../utils/services/AlertLoaderService";
import * as Rxjs from "../../utils/services/subject-behaviour/CommonRxjsService";
import * as CommonUtils from '../../utils/services/CommonUtils';
import * as Redux from '../../utils/services/redux/commonRedux';

const RESEND_OTP_TIME_LIMIT = 30; // 30 secs
const AUTO_SUBMIT_OTP_TIME_LIMIT = 4; // 4 secs

let resendOtpTimerInterval;
let autoSubmitOtpTimerInterval;
var allowResetInputs: boolean = false;

const OTPScreen = function (props) {

    const errorMessage = ''
    const waUpdates = props.route.params?.waUpdates;
    const phoneNumber = props.route.params?.phoneNumber;
    const userName = props.route.params?.userName ?? null

    const navigateFrom = global.navigateFrom;
    const [otpArray, setOtpArray] = useState(['', '', '', '']);
    const [submittingOtp, setSubmittingOtp] = useState(true);

    const [toastData, setToastData] = useState({
        showToast: false, text: ''
    })

    // in secs, if value is greater than 0 then button will be disabled
    const [resendButtonDisabledTime, setResendButtonDisabledTime] = useState(
        RESEND_OTP_TIME_LIMIT,
    );

    // 0 < autoSubmitOtpTime < 4 to show auto submitting OTP text
    const [autoSubmitOtpTime, setAutoSubmitOtpTime] = useState(
        AUTO_SUBMIT_OTP_TIME_LIMIT,
    );

    // TextInput refs to focus programmatically while entering OTP
    const firstTextInputRef = useRef<TextInput>(null);
    const secondTextInputRef = useRef<TextInput>(null);
    const thirdTextInputRef = useRef<TextInput>(null);
    const fourthTextInputRef = useRef<TextInput>(null);

    // a reference to autoSubmitOtpTimerIntervalCallback to always get updated value of autoSubmitOtpTime
    const autoSubmitOtpTimerIntervalCallbackReference: any = useRef();

    useEffect(() => {
        // autoSubmitOtpTime value will be set after otp is detected,
        // in that case we have to start auto submit timer
        autoSubmitOtpTimerIntervalCallbackReference.current = autoSubmitOtpTimerIntervalCallback;
    });

    useEffect(() => {
        focusOnInput();
    }, [])

    useEffect(() => {
        let itemExists = otpArray.filter((item) => {
            if (item) return item;
        })
        if (itemExists && itemExists.length === 4) {
            Keyboard.dismiss();
            setTimeout(() => { onSubmitButtonPress() }, 150);
        }
    }, [otpArray])

    const focusOnInput = () => {
        setTimeout(() => {
            firstTextInputRef.current?.focus()
        }, 200);
    }

    useEffect(() => {
        // autoRead()
        startResendOtpTimer();
        Rxjs.popUpOnClickOkSubscription.getpopUpOnClickOk().pipe().subscribe((isCLickOnOk) => {

            if (isCLickOnOk && allowResetInputs) {
                if (firstTextInputRef) {
                    setOtpArray(['', '', '', '']);
                    firstTextInputRef.current && firstTextInputRef.current.focus();
                }
                // onResendOtpButtonPress();
                allowResetInputs = false;
            }
        })

        return () => {
            if (resendOtpTimerInterval) {
                clearInterval(resendOtpTimerInterval);
            }
        };
    }, [resendButtonDisabledTime]);

    const autoRead = () => {
        autoReadOtp()
    }

    const startResendOtpTimer = () => {
        if (resendOtpTimerInterval) {
            clearInterval(resendOtpTimerInterval);
        }
        resendOtpTimerInterval = setInterval(() => {
            if (resendButtonDisabledTime <= 0) {
                clearInterval(resendOtpTimerInterval);
            } else {
                setResendButtonDisabledTime(resendButtonDisabledTime - 1);
            }
        }, 1000);
    };

    const autoSubmitOtpTimerIntervalCallback = () => {
        if (autoSubmitOtpTime <= 0) {
            clearInterval(autoSubmitOtpTimerInterval);

            // submit OTP
            onSubmitButtonPress();
            // setCaptureName(true)
        }
        setAutoSubmitOtpTime(autoSubmitOtpTime - 1);
    };


    const refCallback = textInputRef => node => {
        textInputRef.current = node;
    };

    const onResendOtpButtonPress = () => {
        AlertService.loaderModal.setLoader(true, 0.6)
        if (firstTextInputRef) {
            setOtpArray(['', '', '', '']);
            firstTextInputRef.current && firstTextInputRef.current.focus();
        }
        let requestParams = {
            phoneNumber: phoneNumber,
            origin: location.host
        }
        doPost('accounts/send_otp', requestParams, false)
            .then(() => {
                AlertService.loaderModal.setLoader(false)
                setResendButtonDisabledTime(RESEND_OTP_TIME_LIMIT);
                startResendOtpTimer();
            }, err => { console.log(err); }
            );
    };

    const placeOrder = (userDetails) => {
        Rxjs.OMSOrderDataSubscription.getomsOrderData().
            subscribe((orderDataSubscription: any) => {
                let orderData = orderDataSubscription.orderData;
                let addressData = orderDataSubscription.addressData;
                let userUpdatedData: any = orderDataSubscription.userUpdatedData;
                if (userUpdatedData?.['name'] && !userDetails['isNameCaptured']) {
                    userDetails['isNameCaptured'] = true
                    userDetails['name'] = userUpdatedData['name'];
                    userUpdatedData['id'] = userDetails['id']
                    userUpdatedData['userId'] = userDetails['id']
                    Redux.updateUserDetails(userDetails)
                } else userUpdatedData = {}

                // Condition to check
                // Medication, images, location

                orderData = buildOrderRequestData({
                    ...orderData,
                    userDetails: userDetails
                })

                if (orderData) {
                    setTimeout(() => {
                        PlaceOMSOrder(props, {
                            orderData: orderData, addressData: addressData,
                            userUpdatedData: userUpdatedData
                        })
                    }, 200)
                }
            }).unsubscribe()
    }

    const intialiseUserAppData = () => {
        const reduxState = store.getState();
        const chemistStoreLoaded = CommonUtils.isChemistStoreLoaded()
        let refreshList = []
        if (chemistStoreLoaded) {
            refreshList.push({ name: RefreshCacheAction.refreshChemistStoreData })
            refreshList.push({
                name: RefreshCacheAction.refreshUserProfileData,
                requestData: { pharmacyId: getSelectedChemistStoreId(reduxState) }
            })
            refreshList.push({
                name: RefreshCacheAction.refreshOrderAndEconsultData,
                requestData: { fetchOrders: true }
            })
        } else {
            refreshList.push({
                name: RefreshCacheAction.refreshUserProfileData,
                requestData: { getVisitedStores: true }
            })
            refreshList.push({
                name: RefreshCacheAction.refreshOrderAndEconsultData,
                requestData: { fetchConsultations: true }
            })
        }
        Rxjs.CacheDataToRefresh.setRefreshList(refreshList)
    }

    const onSubmitButtonPress = () => {
        AlertService.loaderModal.setLoader(true, 0.6)
        let otpDigits = otpArray.join(',').split(',').join('')
        const param = {
            appGUID: pwaGUID(),
            otp: otpDigits,
            origin: location.host,
            phoneNumber: phoneNumber,
            whatsappOptState: waUpdates
        }
        if (userName) param['name'] = userName
        trackMoengageEvents(MoengageEvents.otp_submitted);

        doPost('accounts/authenticate', param, false)
            .then((response: any) => {
                if (response && response.token !== null && response.token !== '') {
                    if (response.profileComplete)
                        trackMoengageEvents(MoengageEvents.logged_in);
                    else trackMoengageEvents(MoengageEvents.relogged_in);

                    clearInterval(resendOtpTimerInterval);

                    const userDetails = CommonUtils.getPrimaryUserData(response)

                    Redux.updateTokenInfo(response);
                    Redux.updateLoginStatus(true);
                    Redux.updateUserDetails(userDetails);

                    intialiseUserAppData()

                    if (navigateFrom == NavigateFrom.add_address_for_create_order) {
                        setTimeout(() => { placeOrder(userDetails) }, 50);
                    } else if (navigateFrom == NavigateFrom.dashboard_for_econsult) {
                        windowGTagEvent({ 'send_to': 'AW-713052563/RGA1CNa05uMCEJOjgdQC' })
                        setTimeout(() => {
                            if (props.navigation.canGoBack())
                                props.navigation.popToTop();
                            global.appHandledBackpress = true;
                            userDetails['isProfileComplete'] ?
                                props.navigation.replace(ScreenRoute.dashboard_screen) :
                                props.navigation.replace(ScreenRoute.complete_profile,
                                    { screenRedirect: ScreenRoute.member_selection });
                        }, 50);
                    } else if (navigateFrom == NavigateFrom.acs_plans) {
                        setTimeout(() => {
                            if (props.navigation.canGoBack())
                                props.navigation.popToTop();
                            global.appHandledBackpress = true;
                            userDetails['isProfileComplete'] ?
                                props.navigation.replace(ScreenRoute.dashboard_screen) :
                                props.navigation.replace(ScreenRoute.complete_profile, {
                                    screenRedirect: ScreenRoute.dashboard_screen,
                                    isGeneralFlow: true
                                });
                        }, 50);
                    } else if (navigateFrom == NavigateFrom.site_store_profile) {
                        setTimeout(() => {
                            if (props.navigation.canGoBack())
                                props.navigation.popToTop();
                            props.navigation.replace(ScreenRoute.site_store_profile);
                        }, 50);
                    } else if (navigateFrom == NavigateFrom.deeplink_message_view) {
                        setTimeout(() => {
                            if (props.navigation.canGoBack())
                                props.navigation.popToTop();
                            props.navigation.replace(ScreenRoute.tab_controller_screen);
                        }, 50);
                    } else if (navigateFrom == NavigateFrom.deeplink_order_summary) {
                        setTimeout(() => {
                            if (props.navigation.canGoBack())
                                props.navigation.popToTop();
                            props.navigation.replace(ScreenRoute.tab_controller_screen);
                        }, 50);
                    } else {
                        setTimeout(() => {
                            if (props.navigation.canGoBack())
                                props.navigation.popToTop();
                            NavigateToAppBaseScreen(props.navigation)
                        }, 50);
                    }
                    AlertService.loaderModal.setLoader(false);
                } else {
                    AlertService.loaderModal.setLoader(false)
                    allowResetInputs = true;
                    setSubmittingOtp(true);
                    setOtpArray(['', '', '', '']);
                }
            }, error => {
                setToastData({ showToast: true, text: getToastContent(error['msg']) })
                AlertService.loaderModal.setLoader(false)
            });
    };

    // this event won't be fired when text changes from '' to '' i.e. backspace is pressed
    // using onOtpKeyPress for this purpose
    const onOtpChange = index => {
        return value => {
            value = value.replace(/[^0-9]/g, '')
            // do nothing when a non digit is pressed
            // auto focus to next InputText if value is not blank
            if (value !== '') {
                const otpArrayCopy = otpArray.concat();
                otpArrayCopy[index] = value;
                setOtpArray(otpArrayCopy);
                setSubmittingOtp(true);
                if (index === 0) {
                    secondTextInputRef.current && secondTextInputRef.current.focus();
                } else if (index === 1) {
                    thirdTextInputRef.current && thirdTextInputRef.current.focus();
                } else if (index === 2) {
                    fourthTextInputRef.current && fourthTextInputRef.current.focus();
                } else if (index === 3) {
                    setSubmittingOtp(false);
                }
            }
        };
    };

    const onOtpKeyPress = index => {
        return ({ nativeEvent: { key: value } }) => {
            // auto focus to previous InputText if value is blank and existing value is also blank
            if (value === 'Backspace') {
                if (otpArray[index] === '') {
                    if (index === 1) {
                        firstTextInputRef.current && firstTextInputRef.current.focus();
                    } else if (index === 2) {
                        secondTextInputRef.current && secondTextInputRef.current.focus();
                    } else if (index === 3) {
                        thirdTextInputRef.current && thirdTextInputRef.current.focus();
                    }

                    if (index > 0) {
                        const otpArrayCopy = otpArray.concat();
                        otpArrayCopy[index - 1] = ''; // clear the previous box which will be in focus
                        setOtpArray(otpArrayCopy);
                    }
                } else {
                    if (index === 0) {
                        firstTextInputRef.current && firstTextInputRef.current.focus();
                    } else if (index === 1) {
                        secondTextInputRef.current && secondTextInputRef.current.focus();
                    } else if (index === 2) {
                        thirdTextInputRef.current && thirdTextInputRef.current.focus();
                    } else if (index === 3) {
                        fourthTextInputRef.current && fourthTextInputRef.current.focus();
                    }
                    const otpArrayCopy = otpArray.concat();
                    otpArrayCopy[index] = ''; // clear the previous box which will be in focus
                    setOtpArray(otpArrayCopy);
                }
            }
        };
    };

    return (
        <View style={{ height: window.innerHeight, backgroundColor: AppTheme.color.background }}>

            <CommonHeader navigation={props.navigation} />

            <View style={{
                backgroundColor: AppTheme.color.background,
                paddingHorizontal: 16, paddingVertical: 17.2,
                marginTop: AppTheme.headerHeight
            }}>
                <Text style={TextStyle.text16xb}>Verify Your Number</Text>
                <View style={{ height: 12 }} />
                <Text style={{ fontSize: 14, fontWeight: "bold" }}>Enter OTP sent to your registered mobile number</Text>
                <View style={{ height: 8 }} />
                <Text style={{ fontSize: 14, fontWeight: "700" }}>{phoneNumber}
                    <Text onPress={() => { global.appHandledBackpress = true; props.navigation.pop() }}
                        style={{ fontSize: 14, color: AppTheme.color.primary }}> Change</Text></Text>
                <View style={{ height: 24 }} />

                <View style={[AppStyles.mediumShadow, { backgroundColor: 'white', padding: 16, borderRadius: 12 }]}>
                    <Text style={{ fontSize: 14, fontWeight: 'bold' }}>Enter the OTP</Text>
                    <View style={{ height: 19 }} />
                    <View style={[AppStyles.flexRowSpaceBetween]}>
                        {[
                            firstTextInputRef,
                            secondTextInputRef,
                            thirdTextInputRef,
                            fourthTextInputRef,
                        ].map((textInputRef, index) => (
                            <OTPTextInput
                                containerStyle={[]}
                                applyBorder={otpArray[index] ? true : false}
                                value={otpArray[index]}
                                onKeyPress={onOtpKeyPress(index)}
                                onChangeText={onOtpChange(index)}
                                keyboardType={'numeric'}
                                maxLength={1}
                                style={[TextStyle.text18xb, TextStyle.alignCenter,
                                { colors: AppTheme.color.primary }]}
                                autoFocus={index === 0 ? true : undefined}
                                refCallback={refCallback(textInputRef)}
                                key={index}
                            />
                        ))}
                    </View>
                    <View style={{ height: 24 }} />
                    <View style={{}}>

                        {errorMessage ? <Text style={[TextStyle.alignCenter,
                        AppStyles.mt12, { color: AppTheme.color.red.highlight }]}>
                            {errorMessage}
                        </Text> : null}

                        {resendButtonDisabledTime > 0 ? (<View style={[AppStyles.flexRow]}>
                            <Image source={{ uri: CommonUtils.getImagePath('/images/icons/message_dashed_grey.svg'), width: 19, height: 18 }} />
                            <View style={{ width: 8 }} />
                            <Text style={{ fontSize: 14, fontWeight: 'bold', color: AppTheme.color.grey.disable }}>
                                Resend OTP in 00:{resendButtonDisabledTime}</Text></View>) :
                            <Pressable style={[AppStyles.flexRow]} onPress={onResendOtpButtonPress}
                                onLongPress={() => { console.log('### long press') }}>
                                <Image source={{ uri: CommonUtils.getImagePath('/images/icons/message_dashed_blue.svg'), width: 19, height: 18 }} />
                                <View style={{ width: 8 }} />
                                <Text style={{ fontSize: 14, fontWeight: 'bold', color: AppTheme.color.primary }}>
                                    Didn't receive the OTP? Resend OTP</Text></Pressable>
                        }
                    </View>
                </View>
            </View>

            <ToastModal showToast={toastData['showToast']}
                setToast={(toastData: any) => { setToastData(toastData) }}
                text={toastData['text']} />
        </View>
    );
};


export default OTPScreen

OTPScreen.defaultProps = {
    attempts: 5,
    otpRequestData: {
        username: 'ratank',
        phone_no: true,
    },
};

OTPScreen.propTypes = {
    otpRequestData: PropTypes.object.isRequired,
    attempts: PropTypes.number.isRequired,
};


